import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { saveDrivingLicense } from "../../../actions/DrivingLicenseActions";
import Toast from "../../../components/Toast";

function DrivingLicenseModal() {

    const dispatch = useDispatch();

    // const [drivingLicenseId, setDrivingLicenseId] = useState('');
    const [expiryDate, setExpiryDate] = useState('');
    const [licenseNo, setLicenseNo] = useState('');
    const [name, setName] = useState('');

    const save = () => {
        if (expiryDate.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Expiry Date is Required!'
            })
        } else if (licenseNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'License No. is Required!'
            })
        } else if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                expiry_date: expiryDate,
                license_no: licenseNo,
                name: name,
            }
            dispatch(saveDrivingLicense(data));
        }
    }

    return (
        <React.Fragment>
            {/* Edit Driving Licence Modal */}
            <div id="driving-licence-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Driving Licence</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            <form>
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-6">
                                        <label for="expiry_date" className="form-label">Expiry Date :</label>
                                        <div className="input-group mx-auto ">
                                            <div id="input-group-email" className="input-group-text "> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-calendar w-4 h-4"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg> </div> <input type="date" placeholder="Enter Expiry Date"  onChange={(e) => setExpiryDate(e.target.value)} id="expiry_date" name="expiry_date" className="datepicker form-control " data-single-mode="true" />
                                        </div>
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="licence_no" className="form-label"> Licence No. :</label>
                                        <input id="licence_no" onChange={(e) => setLicenseNo(e.target.value)} name="licence_no" type="text" className="form-control" placeholder="Enter Licence No" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-12">
                                        <label for="name" className="form-label">Name :</label>
                                        <input id="name" onChange={(e) => setName(e.target.value)} name="name" type="text" required className="form-control" placeholder="Enter Name" />
                                    </div>
                                    <div className="intro-y g-col-12">
                                        <label for="image" className="form-label">Image:</label>
                                        <div className="dropzone text-center pt-10">
                                            <div className="fallback ms-5"> <input name="file" type="file" multiple /> </div>
                                            <div className="dz-message mt-3" data-dz-message>
                                                <div className="fs-lg fw-medium">Drop files here or click to upload.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button>
                            <button type="button" onClick={save} data-bs-dismiss="modal" className="btn btn-primary w-20">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
            {/*End Edit Driving Licence Modal */}
        </React.Fragment>
    )
}

export default DrivingLicenseModal;